import axiosInstance from './axiosInstance';

const createSubsidy = (data) =>
  axiosInstance.post('/internal/admin/subsidies', data);

export default createSubsidy;
